module.exports = __webpack_public_path__ + "static/media/skeletons choice.b7bbb0a6.ai";